module.exports = __webpack_public_path__ + "img/config-pic.136e726c.png";